module.exports = __webpack_public_path__ + "static/logo-585fa41f2a5011a2dbd6ae78db27576b.png";